<template>
  <div>
    <page-breadcrumb :title="currentArea.name" :routes="routes" />
    <div class="vx-row" v-if="cameras.length > 0">
      <div
        v-for="(camera, idx) in cameras"
        :key="idx"
        class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-8"
      >
        <camera-cards :cam="camera" />
      </div>
    </div>
    <div class="vx-row" v-else>
      <div class="vx-col w-full mb-8">
        <vx-card>
          <h2>No Camera Found</h2>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import CameraCards from "../components/camera-cards";
import PageBreadcrumb from "../components/PageBreadcrumb.vue";
import api from "../api";

export default {
  data() {
    return {
      cameras: [],
    };
  },
  components: {
    CameraCards,
    PageBreadcrumb,
  },
  computed: {
    currentSite() {
      return this.$store.state.currentSite;
    },
    areas() {
      return this.$store.state.areas;
    },
    currentArea() {
      return this.$store.state.currentArea;
    },
    routes() {
      return {
        ...this.$route,
        meta: {
          ...this.$route.meta,
          breadcrumb: [
            { title: "Dashboard", url: "/" },
            {
              title: this.currentSite.name,
              url: "/site/" + this.currentSite.id,
            },
            { title: this.currentArea.name, active: true },
          ],
        },
      };
    },
  },
  created() {
    this.$vs.loading();
    this.getCameraLists();
    this.repeatFetahData();
  },
  beforeMount() {
    const currentArea = this.areas.find((v) => v.id == this.$route.params.id);
    this.$store.dispatch("updateCurrentArea", currentArea);
  },
  methods: {
    getCameraLists() {
      api
        .cameraLists({ AreaId: this.$route.params.id })
        .then((result) => result.data.data)
        .then((data) => {
          this.cameras = data;
          this.$vs.loading.close();
        });
    },
    repeatFetahData() {
      const self = this;
      setInterval(function () {
        self.getCameraLists();
      }, 60000); // 1 menit
    },
  },
};
</script>
